import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { ICreateRequest } from "interfaces/create-duck";
import { requestErrorHandler } from "utils";
import { CreatePlantActions } from "store/ducks/settings/plant";

export function* createPlantRequest(action: any) {
  try {
    const { postData, onSuccess } = action as ICreateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.post,
      `/plants`,
      postData
    );

    const { data } = responseBody;
    yield put(CreatePlantActions.success(data));
    notify("success", "Tipo adicionado com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(CreatePlantActions.failure(errorMessage));
  }
}
